@import '../../../../../constants/screen-width-breakpoints.module.less';

.marketplace-setup-modal {
  @media @tablet, @desktop, @widescreen, @ultrawide {
    height: 598px;
    width: 832px;
  }
}

.modal-body {
  height: 100%;
  max-height: 100%;
  overflow: hidden;

  @media @mobile {
    height: calc(100vh - 50px);
  }
}

.iframe {
  width: 100%;
  height: calc(100% - 1px);
  border: 0;
}
